import config from '../config';

export const getAdminUrl = (locationId?: number) => (locationId ? getLocationAdminUrl(locationId) : getUrl());

const getUrl = () => (config.env === 'prod' ? 'https://admin.favrit.com/' : 'https://admin.qa.favrit.com/');
export const getLocationAdminUrl = (locationId: number) => `${getUrl()}#/location/${locationId}`;

export const getOrderHistoryUrl = (locationId: number) => `${getUrl()}#/location/${locationId}/order-history`;
